module.exports = __webpack_public_path__ + "static/media/design-img-3.18d40c8b.jpg";